import type { LucideIcon } from "lucide-react";
import { Construction } from "lucide-react";
import { Card, CardBody } from "@hp/ui";

interface ComingSoonPageProps {
  label: string;
  icon?: LucideIcon;
}

/**
 * Placeholder shown in the overview-only demo for a sidebar item that has a
 * real page in the full app but isn't part of this demo. Reached by actually
 * clicking the nav item (it's a real route), not by a disabled link.
 */
export function ComingSoonPage({ label, icon: Icon = Construction }: ComingSoonPageProps) {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <Card className="max-w-md">
        <CardBody className="flex flex-col items-center gap-3 px-8 py-10 text-center">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-zinc-100 text-zinc-400">
            <Icon className="h-6 w-6" aria-hidden />
          </span>
          <h2 className="font-serif text-lg font-semibold text-zinc-900">{label}</h2>
          <span className="rounded-full bg-zinc-100 px-3 py-1 text-xs font-medium uppercase tracking-wide text-zinc-400">
            Coming soon
          </span>
        </CardBody>
      </Card>
    </div>
  );
}
